export default __webpack_public_path__ + "static/media/floor.6648f810.svg";